export const KEYS = {
  THEMING: {
    THEMING: 'CI / Design',
    APPEARANCE: 'Darstellung',
    ADMIN: 'Verwaltungsoberfläche',
    APP: 'Ausfüll-App',
    CSS_CUSTOMIZATION_WARNING: 'Es ist nicht garantiert, dass benutzerdefinierte CSS-Regeln in zukünftigen Versionen unverändert funktionieren. Wenn die zugrunde liegende Technik aktualisiert wird, kann es erforderlich sein, diese anzupassen oder neu zu erstellen.',
  }
};
